import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

interface CallAttendanceModalProps {
  open: boolean;
  weekNumber: number;
  weekTitle: string;
  onSelect: (type: 'live' | 'replay') => void;
}

const CallAttendanceModal = ({ open, weekNumber, weekTitle, onSelect }: CallAttendanceModalProps) => (
  <Dialog open={open} onOpenChange={() => {}}>
    <DialogContent className="bg-card border-border" onPointerDownOutside={e => e.preventDefault()} onEscapeKeyDown={e => e.preventDefault()}>
      <DialogHeader>
        <DialogTitle className="font-serif text-foreground">One quick question</DialogTitle>
        <DialogDescription className="text-muted-foreground">
          Did you attend Week {weekNumber}: {weekTitle} live, or did you watch the replay?
        </DialogDescription>
      </DialogHeader>
      <div className="flex gap-3 mt-2">
        <Button
          variant="outline"
          onClick={() => onSelect('replay')}
          className="flex-1"
        >
          I watched the replay
        </Button>
        <Button
          onClick={() => onSelect('live')}
          className="flex-1 gradient-gold text-primary-foreground font-semibold shadow-gold hover:opacity-90"
        >
          I attended live
        </Button>
      </div>
    </DialogContent>
  </Dialog>
);

export default CallAttendanceModal;
